import { IDropZoneWorkflowState } from 'interfaces/designOrchestration/designOrchestrationState.interface';
import { Useuid } from 'utils/hooks/useUid';
import style from './DesignOrchestrationDiagram.module.scss';
import {
  IDropZoneStepGroup,
  IOrchestrationNodeDropZone,
} from 'interfaces/designOrchestration/designOrchestrationDiagram.interface';
import { FlowNode } from './DesignOrchestrationDiagram';

export enum DEFAULT_NODES_IDS {
  ORCHESTRATION_STEPS = '1',
  INITIAL_DROPZONE = '2',
  GLOBAL_FAILBACK_STEPS = '3',
  INITIAL_FAILBACK_DROPZONE = '4',
  LEGEND_NODE = '5',
}

export enum DROPZONE_TYPES {
  PREDECESSOR = '0',
  SUCCEDING = '1',
  NESTED = '2',
  NESTED_FAILBACK = '3',
  PARALLEL = '4',
  GLOBAL_FAILBACK_STEPS = '5',
  SUCCEDING_FAILBACK = '6',
  PARALLEL_FAILBACK = '7',
  PREDECESSOR_FAILBACK = '8',
  PARALLEL_GLOBAL_FAILBACK = '9',
  NESTED_GLOBAL_FAILBACK = '10',
  SUCCEDING_GLOBAL_FAILBACK = '11',
}

export enum DROPZONES_NAMES {
  PREDECESSOR = 'Predecessor',
  SUCCEDING = 'Succeeding',
  NESTED = 'Nested',
  FAILBACK = 'Failback',
  PARALLEL = 'Parallel',
  PARALLEL_FAILBACK = 'Parallel Failback',
  GLOBAL_FAILBACK_STEPS = 'Global Failback Steps',
  SUCCEDING_FAILBACK = 'Succeeding Failback',
  PREDECESSOR_FAILBACK = 'Predecessor Failback',
  PARALLEL_GLOBAL_FAILBACK = 'Parallel Global Failback',
}

export const DEFAULT_NODES: IOrchestrationNodeDropZone[] = [
  {
    id: DEFAULT_NODES_IDS.ORCHESTRATION_STEPS,
    type: 'headerNode',
    position: { x: 20, y: 20 },
    data: {
      label: 'Orchestration Steps:',
      stepType: 'label',
    },
  },
  {
    id: DEFAULT_NODES_IDS.INITIAL_DROPZONE,
    type: 'dropZoneNode',
    position: { x: 150, y: 60 },
    data: {
      id: '2',
      tooltip:
        'Drag and drop your module here to add a step to your orchestration',
      stepType: 'step',
      dropzoneType: DROPZONE_TYPES.SUCCEDING,
    },
  },

  {
    id: DEFAULT_NODES_IDS.GLOBAL_FAILBACK_STEPS,
    type: 'headerNode',
    position: { x: 20, y: 150 },
    data: {
      label: 'Orchestration Global Failback Steps:',
      stepType: 'label',
    },
  },
  {
    id: DEFAULT_NODES_IDS.INITIAL_FAILBACK_DROPZONE,
    type: 'dropZoneNode',
    position: { x: 150, y: 200 },
    data: {
      id: '4',
      tooltip:
        "Drag and drop your failback module here. Modules in the 'Global failback drop zone' will be executed if the orchestration fails",
      stepType: 'globalFailback',
      dropzoneType: DROPZONE_TYPES.GLOBAL_FAILBACK_STEPS,
    },
  },
  {
    id: DEFAULT_NODES_IDS.LEGEND_NODE,
    type: 'legendNode',
    position: { x: 2000, y: 20 },
    className: style['node-transition'],
    data: {
      label: 'Orchestration Global Failback Steps:',
      stepType: 'label',
    },
  },
];

export const MINIMUM_CANVAS_SIZE_NO_NODES = 700;
export const MINIMUM_CANVAS_SIZE = 1040;

export const NEW_MODULE: IDropZoneStepGroup = {
  workflowStepGroupId: null,
  parentWorkflowStepGroupId: null,
  steps: [
    {
      workflowStepId: Math.floor(Math.random() * 1000000),
      workflowStepGroupId: null,
      stepTitle: null,
      stepId: Useuid(),
      stepIndex: null,
      module: {
        id: null,
        textId: '',
        version: '',
        name: '',
        description: '',
        parameters: [],
      },
      paramGroups: [],
      nestedStepGroup: null,
      failbackStepGroup: null,
    },
  ],
  nextStepGroup: null,
};

export const WORKFLOW_INITIAL_OBJECT: IDropZoneWorkflowState = {
  workflow: {
    name: '',
    nextStepGroup: {
      workflowStepGroupId: -1,
      parentWorkflowStepGroupId: null,
      steps: [
        {
          workflowStepId: DEFAULT_NODES_IDS.INITIAL_DROPZONE,
          workflowStepGroupId: null,
          stepTitle: DROPZONES_NAMES.SUCCEDING,
          stepId: DROPZONE_TYPES.SUCCEDING,
          stepCondition: null,
          stepIndex: null,
          module: {
            id: null,
            textId: '',
            version: '',
            name: '',
            description: '',
            parameters: [],
          },
          paramGroups: [],
          nestedStepGroup: null,
          failbackStepGroup: null,
        },
      ],
      nextStepGroup: null,
    },
    failbackStepGroup: {
      workflowStepGroupId: -2,
      parentWorkflowStepGroupId: null,
      steps: [
        {
          workflowStepId: DEFAULT_NODES_IDS.INITIAL_FAILBACK_DROPZONE,
          workflowStepGroupId: null,
          stepTitle: DROPZONES_NAMES.GLOBAL_FAILBACK_STEPS,
          stepId: DROPZONE_TYPES.GLOBAL_FAILBACK_STEPS,
          stepCondition: null,
          stepIndex: null,
          module: {
            id: null,
            textId: '',
            version: '',
            name: '',
            description: '',
            parameters: [],
          },
          paramGroups: [],
          nestedStepGroup: null,
          failbackStepGroup: null,
        },
      ],
      nextStepGroup: null,
    },
  },
  steps: [],
};

export const WORKFLOW_MOCK_FROM_BASIC_MODULE: IDropZoneWorkflowState = {
  workflow: {
    name: '',
    nextStepGroup: {
      workflowStepGroupId: null,
      parentWorkflowStepGroupId: null,
      steps: [
        {
          workflowStepId: 1744741560324,
          workflowStepGroupId: null,
          stepTitle: 'Predecessor',
          stepId: DROPZONE_TYPES.PREDECESSOR,
          stepIndex: null,
          module: {
            id: null,
            textId: '',
            version: '',
            name: '',
            description: '',
            parameters: [],
          },
          paramGroups: [],
          nestedStepGroup: null,
          failbackStepGroup: null,
          associatedMainNodeId: 1744741562483,
          nestGroupId: ['1744741562483'],
        },
      ],
      nextStepGroup: {
        workflowStepGroupId: null,
        parentWorkflowStepGroupId: null,
        steps: [
          {
            workflowStepId: 1744741562483,
            workflowStepGroupId: null,
            stepTitle: 'System Aggregator',
            stepId: '1iotb6lv0096c8f63a39a0f',
            stepIndex: 1,
            module: {
              id: 302,
              textId: 'system-aggregator',
              version: '',
              name: 'System Aggregator',
              description: 'Aggregate batches.',
              parameters: [],
            },
            paramGroups: [
              {
                groupTitle: null,
                groupCondition: null,
                parameters: [
                  {
                    parameter: {
                      type: 'BOOLEAN',
                      value: null,
                      id: 5858,
                      textId: 'skipContent',
                      name: 'Content is not needed',
                      required: false,
                      default: 'false',
                      dependsId: null,
                      dependsValue: null,
                      dynamicValues: false,
                      tooltip: null,
                      defaultText: null,
                    },
                    value: null,
                  },
                  {
                    parameter: {
                      type: 'BOOLEAN',
                      value: null,
                      id: 5859,
                      textId: 'failIfOneFailed',
                      name: 'Fail if one failed',
                      required: false,
                      default: 'false',
                      dependsId: null,
                      dependsValue: null,
                      dynamicValues: false,
                      tooltip: null,
                      defaultText: null,
                    },
                    value: null,
                  },
                ],
              },
            ],
            nestedStepGroup: null,
            failbackStepGroup: {
              workflowStepGroupId: null,
              parentWorkflowStepGroupId: null,
              steps: [
                {
                  workflowStepId: 1744741562510,
                  workflowStepGroupId: null,
                  stepTitle: 'Failback',
                  stepId: DROPZONE_TYPES.NESTED_FAILBACK,
                  stepIndex: null,
                  module: {
                    id: null,
                    textId: '',
                    version: '',
                    name: '',
                    description: '',
                    parameters: [],
                  },
                  paramGroups: [],
                  nestedStepGroup: null,
                  failbackStepGroup: null,
                  associatedMainNodeId: 1744741562483,
                },
              ],
              nextStepGroup: null,
            },
            nestGroupId: [],
            associatedMainNodeId: 1744741562483,
          },
          {
            workflowStepId: 1744741566420,
            workflowStepGroupId: null,
            stepTitle: 'Parallel',
            stepId: DROPZONE_TYPES.PARALLEL,
            stepIndex: null,
            module: {
              id: null,
              textId: '',
              version: '',
              name: '',
              description: '',
              parameters: [],
            },
            paramGroups: [],
            nestedStepGroup: null,
            failbackStepGroup: null,
            associatedMainNodeId: 1744741562483,
            nestGroupId: [],
          },
        ],
        nextStepGroup: {
          workflowStepGroupId: null,
          parentWorkflowStepGroupId: null,
          steps: [
            {
              workflowStepId: 1744741560157,
              workflowStepGroupId: null,
              stepTitle: 'Succeeding',
              stepId: DROPZONE_TYPES.SUCCEDING,
              stepIndex: null,
              module: {
                id: null,
                textId: '',
                version: '',
                name: '',
                description: '',
                parameters: [],
              },
              paramGroups: [],
              nestedStepGroup: null,
              failbackStepGroup: null,
              associatedMainNodeId: 1744741562483,
              nestGroupId: ['1744741562483'],
            },
          ],
          nextStepGroup: null,
        },
      },
    },
    failbackStepGroup: null,
  },
  steps: [
    {
      jobStepId: -1,
      jobId: -1,
      workflowStepId: DEFAULT_NODES_IDS.INITIAL_DROPZONE,
      submitTime: '',
      startTime: '',
      endTime: '',
      status: '',
      executionNumber: 0,
      jobStepParams: [],
      sqsQueueName: '',
      ec2Instance: null,
    },
  ],
};

export const WORKFLOW_MOCK_FROM_FAILBACK_MODULE: IDropZoneWorkflowState = {
  workflow: {
    name: '',
    nextStepGroup: {
      workflowStepGroupId: null,
      parentWorkflowStepGroupId: null,
      steps: [
        {
          workflowStepId: 1746034190980,
          workflowStepGroupId: null,
          stepTitle: 'Predecessor',
          stepId: '0',
          stepIndex: null,
          module: {
            id: null,
            textId: '',
            version: '',
            name: '',
            description: '',
            parameters: [],
          },
          paramGroups: [],
          nestedStepGroup: null,
          failbackStepGroup: null,
          associatedMainNodeId: 1746034194344,
          nestGroupId: ['1746034194344'],
        },
      ],
      nextStepGroup: {
        workflowStepGroupId: null,
        parentWorkflowStepGroupId: null,
        steps: [
          {
            workflowStepId: 1746034194344,
            workflowStepGroupId: null,
            stepTitle: 'System Noop',
            stepId: '1iq3ruift0b175731bb4b0f',
            stepIndex: 1,
            module: {
              id: 303,
              textId: 'system-noop',
              version: '',
              name: 'System Noop',
              description: 'Do nothing.',
              parameters: [],
            },
            paramGroups: [
              {
                groupTitle: null,
                groupCondition: null,
                parameters: [],
              },
            ],
            nestedStepGroup: null,
            failbackStepGroup: {
              workflowStepGroupId: null,
              parentWorkflowStepGroupId: null,
              steps: [
                {
                  workflowStepId: 1746034192235,
                  workflowStepGroupId: 1746034189947,
                  stepTitle: 'Predecessor',
                  stepId: '0',
                  stepIndex: null,
                  module: {
                    id: null,
                    textId: '',
                    version: '',
                    name: '',
                    description: '',
                    parameters: [],
                  },
                  paramGroups: [],
                  nestedStepGroup: null,
                  failbackStepGroup: null,
                  associatedMainNodeId: 1746034189947,
                  nestGroupId: ['1746034189947', '1746034189947'],
                },
              ],
              nextStepGroup: {
                workflowStepGroupId: null,
                parentWorkflowStepGroupId: null,
                steps: [
                  {
                    workflowStepId: 1746034189947,
                    workflowStepGroupId: 1746034189947,
                    stepTitle: 'System Splitter',
                    stepId: '1iq3ruift0b175731bb4b0f',
                    stepIndex: 2,
                    module: {
                      id: 301,
                      textId: 'system-splitter',
                      version: '',
                      name: 'System Splitter',
                      description: 'Split into batches.',
                      parameters: [],
                    },
                    paramGroups: [
                      {
                        groupTitle: null,
                        groupCondition: null,
                        parameters: [
                          {
                            parameter: {
                              type: 'INTEGER',
                              value: null,
                              id: 5287,
                              textId: 'maxNumberOfFiles',
                              name: 'Max number of files',
                              required: true,
                              default: '10',
                              dependsId: null,
                              dependsValue: null,
                              dynamicValues: false,
                              tooltip: null,
                              defaultText: null,
                            },
                            value: null,
                          },
                          {
                            parameter: {
                              type: 'INTEGER',
                              value: null,
                              id: 5288,
                              textId: 'maxSizeInBytes',
                              name: 'Max size in bytes',
                              required: true,
                              default: '1048576',
                              dependsId: null,
                              dependsValue: null,
                              dynamicValues: false,
                              tooltip: null,
                              defaultText: null,
                            },
                            value: null,
                          },
                          {
                            parameter: {
                              type: 'ENUM',
                              valueAsArray: ['Unstructured', 'PCI-NG'],
                              value: 'Unstructured',
                              id: 5289,
                              textId: 'contentType',
                              name: 'Content type',
                              required: true,
                              default: 'Unstructured',
                              dependsId: null,
                              dependsValue: null,
                              dynamicValues: false,
                              tooltip: null,
                              defaultText: null,
                              values: ['Unstructured', 'PCI-NG'],
                            },
                            value: 'Unstructured',
                          },
                        ],
                      },
                    ],
                    nestedStepGroup: null,
                    failbackStepGroup: null,
                    nestGroupId: ['1746034189947'],
                  },
                  {
                    workflowStepId: 1746034198240,
                    workflowStepGroupId: 1746034189947,
                    stepTitle: 'Parallel Failback',
                    stepId: '7',
                    stepIndex: null,
                    module: {
                      id: null,
                      textId: '',
                      version: '',
                      name: '',
                      description: '',
                      parameters: [],
                    },
                    paramGroups: [],
                    nestedStepGroup: null,
                    failbackStepGroup: null,
                    nestGroupId: ['1746034189947'],
                  },
                ],
                nextStepGroup: {
                  workflowStepGroupId: null,
                  parentWorkflowStepGroupId: null,
                  steps: [
                    {
                      workflowStepId: 1746034198793,
                      workflowStepGroupId: 1746034189947,
                      stepTitle: 'Succeeding Failback',
                      stepId: '6',
                      stepIndex: null,
                      module: {
                        id: null,
                        textId: '',
                        version: '',
                        name: '',
                        description: '',
                        parameters: [],
                      },
                      paramGroups: [],
                      nestedStepGroup: null,
                      failbackStepGroup: null,
                      associatedMainNodeId: 1746034189947,
                      nestGroupId: ['1746034189947', '1746034189947'],
                    },
                  ],
                  nextStepGroup: null,
                },
              },
            },
            nestGroupId: [],
            associatedMainNodeId: 1746034194344,
          },
          {
            workflowStepId: 1746034192210,
            workflowStepGroupId: null,
            stepTitle: 'Parallel',
            stepId: '4',
            stepIndex: null,
            module: {
              id: null,
              textId: '',
              version: '',
              name: '',
              description: '',
              parameters: [],
            },
            paramGroups: [],
            nestedStepGroup: null,
            failbackStepGroup: null,
            associatedMainNodeId: 1746034194344,
            nestGroupId: [],
          },
        ],
        nextStepGroup: {
          workflowStepGroupId: null,
          parentWorkflowStepGroupId: null,
          steps: [
            {
              workflowStepId: 1746034193222,
              workflowStepGroupId: null,
              stepTitle: 'Succeeding',
              stepId: '1',
              stepIndex: null,
              module: {
                id: null,
                textId: '',
                version: '',
                name: '',
                description: '',
                parameters: [],
              },
              paramGroups: [],
              nestedStepGroup: null,
              failbackStepGroup: null,
              associatedMainNodeId: 1746034194344,
              nestGroupId: ['1746034194344'],
            },
          ],
          nextStepGroup: null,
        },
      },
    },
    failbackStepGroup: null,
  },
  steps: [
    {
      jobStepId: -1,
      jobId: -1,
      workflowStepId: '2',
      submitTime: '',
      startTime: '',
      endTime: '',
      status: '',
      executionNumber: 0,
      jobStepParams: [],
      sqsQueueName: '',
      ec2Instance: null,
    },
  ],
};

// Default initial nodes positions and constants
export const DROPZONES_X_OFFSET = 200;
export const LEGEND_MARGIN = 300;
export const FAILBACK_NODE_MARGIN = 66;
export const FAILBACK_LABEL_MARGIN = 96;
export const LEGEND_NODE_X_MARGIN = 235;
export const UPDATE_POSITION_DELAY = 300;
export const DEFAULT_CONTAINER_WIDTH = 1000;

export const generateDefaultNodes = (
  currentNodes: FlowNode[],
  containerWidth: number,
  isDefaultLayout: boolean
) => {
  return currentNodes.map((node) => {
    if (node.id === DEFAULT_NODES_IDS.LEGEND_NODE) {
      const maxNodeX = currentNodes
        .filter((n) => n.id !== DEFAULT_NODES_IDS.LEGEND_NODE)
        .reduce((max, n) => Math.max(max, n.position.x), 0);

      const legendX = Math.max(
        maxNodeX + LEGEND_MARGIN,
        containerWidth - LEGEND_NODE_X_MARGIN
      );

      return {
        ...node,
        position: {
          x: legendX,
          y: 20,
        },
      };
    }

    if (node.id === DEFAULT_NODES_IDS.INITIAL_DROPZONE) {
      return {
        ...node,
        position: {
          x: containerWidth / 2 - DROPZONES_X_OFFSET,
          y: node.position.y,
        },
      };
    }

    if (
      node.id === DEFAULT_NODES_IDS.INITIAL_FAILBACK_DROPZONE &&
      isDefaultLayout
    ) {
      return {
        ...node,
        position: {
          x: containerWidth / 2 - DROPZONES_X_OFFSET,
          y: node.position.y,
        },
      };
    }

    if (
      (node.id === DEFAULT_NODES_IDS.ORCHESTRATION_STEPS ||
        node.id === DEFAULT_NODES_IDS.GLOBAL_FAILBACK_STEPS) &&
      isDefaultLayout
    ) {
      return {
        ...node,
        position: {
          x: node.position.x,
          y: node.position.y,
        },
      };
    }
    return node;
  });
};
